import { joinURL } from 'ufo';
import { Buffer } from 'buffer';
// @ts-ignore
import { hmac, sha256 } from 'hash.js';

const config = useRuntimeConfig()

/**
 * `preferCdnInDev`: opt-in for local dev (appBase = localhost:3000). By default local dev keeps the original
 * behaviour for every caller (full URL as-is, bare key -> {apiBase}/api/s3/{key}, the v1 NestJS proxy). A caller
 * whose keys come from Go v2 (no /api/s3 there) passes true to sign through the dev CDN when it is configured.
 */
export const getImage = (src: string, watermark: boolean = false, width: number = 0, height: number = 0, preferCdnInDev: boolean = false) => {
  if (config.public.appBase === 'http://localhost:3000') {
    if (src.startsWith('http')) return src
    const { cdnUrl, cdnKey, cdnSalt } = config.public
    if (!(preferCdnInDev && cdnUrl && cdnKey && cdnSalt)) return `${config.public.apiBase}/api/s3/${src}`
  }

  // Bypass empty values, local asset paths, and data:/blob: URIs — deliberately
  // does NOT bypass http(s): a full URL here means the backend violated the
  // storage-key contract and must fail loudly, not be silently absorbed.
  if (!src || /^(data:|blob:|\/)/.test(src)) return src

  const urlSafeBase64 = (str: string) => {
    return Buffer.from(str, 'utf8')
      .toString('base64')
      .replace(/=/g, '')
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
  }
  const hexDecode = (hex: string) => Buffer.from(hex, 'hex')
  const sign = (salt: string, target: string, secret: string) => {
    const encode = hmac(sha256, hexDecode(secret))
    encode.update(hexDecode(salt))
    encode.update(target)
    return urlSafeBase64(encode.digest())
  }
  const resizingType = 'fill'
  const gravity = 'sm'
  const enlarge = 1
  const encodedUrl = urlSafeBase64(src)
  const path = joinURL('/', `rs:${resizingType}:${width}:${height}:${enlarge}/g:${gravity}/wm:${watermark ? '0.5:we:20:0:0.2' : '0.0:we:20:0:0.2'}/`, encodedUrl);
  const signature = sign(config.public.cdnSalt, path, config.public.cdnKey)

  return joinURL(config.public.cdnUrl, signature, path)
}
